// extracted by mini-css-extract-plugin
module.exports = {"root":"LegacySocialMediaFields_root__89dVo"};